
import { https , httpsFile } from './http.js' ;

export function showActivity ( id,page,currentpage,dateFrom,dateTo,search ) {
    return https().get( `activities/${id}?page=${page}&currentpage=${currentpage}&dateFrom=${dateFrom}&dateTo=${dateTo}&search=${search}` );
}

export function showUserActivity ( id , page , currentpage ) {
    return https().get( `user-activities/${id}?page=${page}&currentpage=${currentpage}` ) ;
}

export function history (id,data){
    return httpsFile().get(`activities/${id}/edit?subject_type=${data}`);
}

export function index(){
    return https().get(`activities`);
}